<template>
  <div class="schoolMeeting">
    <div class="headView">
      <span class="text"></span>
      <template>
        <div class="btns">
          <span class="btn" @click="sendMessage()">发消息</span>
        </div>
      </template>
    </div>
    <PostList from="school" :owner-info="ownerInfo"/>
    <!-- 输入框 -->
    <div class="inputViewContainerShadow" v-if="show_input_shadow" @click.self="hideInputView()">
      <div class="inputViewContainer">
        <InputView type="post" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Utils } from "@/utils";
import PostList from '../PostList'
import InputView from "../components/InputView.vue";

import { types as ToastTypes } from "@/store/modules/toast";
import { types as LoginTypes } from "@/store/modules/login";
import { types as CommunityTypes } from "@/store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "SchoolMeeting",
  components: {
    PostList,
    InputView
  },
  props: {
  },
  data() {
    return {
      show_input_shadow: false
    };
  },
  watch: {},
  computed: {
    ...mapState({
      school: state => state.school.currentSchool,
      ownerInfo: state => state.login.userInfo
    })
  },
  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW
    }),
    ...mapActions({
      fetchCreateEvent: CommunityTypes.FETCH_CREATE_EVENT,
    }),
    ...Utils,
    // 发消息按钮点击事件
    sendMessage(){
      this.openInputView()
    },
    // 打开帖子输入框
    openInputView(){
      this.show_input_shadow = true;
    },
    hideInputView(){
      this.show_input_shadow = false
    },
    
    //-------------inputView 组件的回调函数
    //发帖子
    publish(type, data) {
      data["type"] = type;
      // console.log(data);
      let school_id = this.$route.params.school_id;
      data["school_id"] = school_id;
      this.fetchCreateEvent(data);
      this.hideInputView();
    }
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.schoolMeeting {
  background-color: #f6f6f6;
  padding: 15px;
  min-height: 350px;
  .headView {
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .text {
      color: #666666;
      font-size: 13px;
    }
    .btns{
      display: flex;
      flex-direction: row;
    }
    .btn {
      padding: 3px 10px;
      border-radius: 15px;
      color: #ffffff;
      font-size: 13px;
      background-color: #5024fe;
      cursor: pointer;
      margin-left: 15px;
    }
  }
}
.inputViewContainerShadow{
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 300;
  position: fixed;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  .inputViewContainer {
    width: 770px;
  }
}

</style>
